import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { PermissaoUsuario } from '../../models/usuario/PermissaoUsuario';
import { TipoPermissaoUsuario } from '../../models/usuario/TipoPermissaoUsuario';
import { AuthService } from '../../services/auth';
import { NotificationService } from '../../services/notification';

@Injectable({
  providedIn: 'root',
})
export class PermissaoGuard implements CanActivate {
  router = inject(Router);
  authService = inject(AuthService);
  notification = inject(NotificationService);

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
    return this.authService.usuario$.pipe(
      take(1),
      map((usuario) => {
        if (!usuario) {
          this.showUnauthorizedNotification();
          return false;
        }

        const funcionalidade = this.getFuncionalidade(route);

        if (this.hasPermissao(usuario?.respostaPermissoesDTO, funcionalidade)) {
          return true;
        }

        this.showUnauthorizedNotification();

        return this.router.parseUrl('inicio');
      })
    );
  }

  private getFuncionalidade(
    route: ActivatedRouteSnapshot
  ): TipoPermissaoUsuario {
    return (route.data['permissao'] as TipoPermissaoUsuario) ?? '';
  }

  private hasPermissao(
    permissoes: PermissaoUsuario[],
    funcionalidade: TipoPermissaoUsuario
  ): boolean {
    return (
      permissoes.find(
        (permissao) => permissao.funcionalidade === funcionalidade
      )?.ehPermitido ?? false
    );
  }

  private showUnauthorizedNotification(): void {
    this.notification.info('Você não tem permissão para acessar essa página.');
  }
}
